export const LoadingStatus = {
    EMPTY: 'empty',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error'
};
